import { Dependencies } from "../dependencies/dependencies.model"

export interface Perk {
    masterId: string
    createdByUser: string
    modifiedByUser: string
    createdDate: Date
    modifiedDate: Date
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    version: number
    activeFrom: Date | null
    activeTo: Date | null
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    imageUrl: string
    contact: {
        email: string
        phoneNumber: string
    }
    link: string
    categoryIds: string[]
    locationIds: string[]
    dependencies: Dependencies
}

export interface PerkListItem {
    masterId: string
    createdByUser: string
    modifiedByUser: string
    createdDate: Date
    modifiedDate: Date
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    version: number
    activeFrom: Date | null
    activeTo: Date | null
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    imageUrl: string
    categoryNames: string[]
    locationNames: string[]
}

export interface PagedPerk {
    items: PerkListItem[]
    totalCount: number
}

export const PERK_FIELD_LABELS: Record<string, string> = {
    names: "Naziv",
    descriptions: "Opis",
    activeFrom: "Aktivan od",
    activeTo: "Aktivan do",
    isActive: "Aktivan",
    isDraft: "Skica",
    isDeleted: "Obrisano",
    image: "Slika",
    contact: "Kontakt",
    link: "Link",
    categoryIds: "Kategorije",
    locationIds: "Lokacije",
    dependencies: "Ovisnosti",
}
